<form nz-form [formGroup]="formGroup" (ngSubmit)="submit();">
  <div class="page-content-section">
    <fieldset>
      <legend>
        {{'Information'  | translate}}
      </legend>
      <nz-form-item *ngIf="mode === 'edit'">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Code">
          {{'Id'  | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please insert the id.">
          <input nz-input formControlName="Id" id="Id" readonly />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Code">
          {{'Code' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the code.' | translate">
          <input nz-input formControlName="Code" id="Code" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Title">
          {{'Title' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the title.' | translate">
          <input nz-input formControlName="Title" id="Title" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>{{ 'Has inverse relation' | locale  | translate }}</nz-form-label>
        <nz-form-control>
          <nz-switch nz-input formControlName="hasInverse" id="hasInverse"  [nzCheckedChildren]="'Yes' | locale"
            [nzUnCheckedChildren]="'No' | locale"></nz-switch>
        </nz-form-control>
      </nz-form-item>
      <span *ngIf="this.formGroup.get('hasInverse')?.value">
        <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="CodeOfInver">
          {{'Code of inverse' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please insert the code of inverse.">
          <input nz-input formControlName="CodeOfInver" id="CodeOfInver" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="TitleOfInver">
          {{'Title of inverse' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please insert the title of inverse.">
          <input nz-input formControlName="TitleOfInver" id="TitleOfInver" />
        </nz-form-control>
      </nz-form-item>
      </span>

    </fieldset>
  </div>
  <input type="submit" style="display: none" />
</form>
